import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * MySpaceMyReviewsRefreshEvent
 *
 * - Evento emitido quando a aba de revisões do meu espaço precisa ser atualizada.
 * - Isso pode ocorrer quando: A revisão é `aprovada`, `rejeitada` ou `cancelada`.
 */
export class MySpaceMyReviewsRefreshEvent extends CreateCommand(
  RealtimeEventType.MySpaceMyReviewsRefresh,
  SCHEMA,
) {}
